/*
  Gentsy leverdatum: vervangt de vaste leverzin door een aftelling en een concrete datum.
  Gebruik: <span data-gentsy-delivery data-days="1-2" data-cutoff="15" data-holidays="2026-12-25,...">vaste tekst</span>
  - data-days: werkdagen na verzending (bijv. "1-2" of "2-3")
  - data-cutoff: uur (Nederlandse tijd) tot wanneer we dezelfde dag verzenden
  - werkdagen = maandag t/m vrijdag, minus data-holidays
  De vaste tekst blijft staan als JavaScript uit staat of er iets misgaat.
*/
(function () {
  if (window.GentsyDelivery) return;

  var lang = (document.documentElement.lang || 'nl').slice(0, 2) === 'de' ? 'de' : 'nl';
  var T = {
    nl: { order: 'Bestel binnen', expected: 'verwacht', now: 'Nu besteld', h: 'u', m: 'm' },
    de: { order: 'Bestelle innerhalb von', expected: 'voraussichtlich', now: 'Jetzt bestellt', h: ' Std.', m: ' Min.' }
  }[lang];

  // Huidige datum en tijd in Nederland, los van de tijdzone van de bezoeker
  function amsterdamNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      minutes: +parts.hour * 60 + +parts.minute,
      seconds: +parts.second
    };
  }

  function iso(d) { return d.toISOString().slice(0, 10); }

  function isWorkday(d, holidays) {
    var day = d.getUTCDay();
    return day !== 0 && day !== 6 && holidays.indexOf(iso(d)) === -1;
  }

  function addWorkdays(d, n, holidays) {
    var r = new Date(d);
    while (n > 0) {
      r.setUTCDate(r.getUTCDate() + 1);
      if (isWorkday(r, holidays)) n--;
    }
    return r;
  }

  var fmt = new Intl.DateTimeFormat(lang === 'de' ? 'de-DE' : 'nl-NL', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
  var fmtDay = new Intl.DateTimeFormat(lang === 'de' ? 'de-DE' : 'nl-NL', { timeZone: 'UTC', weekday: 'short', day: 'numeric' });

  function render(el) {
    var days = (el.getAttribute('data-days') || '1-2').split('-').map(Number);
    var min = days[0] || 1;
    var max = days[1] || min;
    var cutoff = Number(el.getAttribute('data-cutoff') || 15) * 60;
    var holidays = (el.getAttribute('data-holidays') || '').split(',').map(function (s) { return s.trim(); });

    var now = amsterdamNow();
    var shipsToday = isWorkday(now.date, holidays) && now.minutes < cutoff;
    var shipDay = shipsToday ? now.date : addWorkdays(now.date, 1, holidays);
    var from = addWorkdays(shipDay, min, holidays);
    var to = addWorkdays(shipDay, max, holidays);

    var range;
    if (iso(from) === iso(to)) range = fmt.format(from);
    else if (from.getUTCMonth() === to.getUTCMonth()) range = fmtDay.format(from) + ' – ' + fmt.format(to);
    else range = fmt.format(from) + ' – ' + fmt.format(to);

    var lead;
    if (shipsToday) {
      var left = cutoff - now.minutes - (now.seconds > 0 ? 1 : 0);
      var h = Math.floor(left / 60);
      var m = left % 60;
      lead = T.order + ' <strong class="gentsy-delivery__time">' + (h > 0 ? h + T.h + ' ' : '') + m + T.m + '</strong>';
    } else {
      lead = T.now;
    }
    el.innerHTML = lead + ', ' + T.expected + ' <strong>' + range + '</strong>';
    el.classList.add('gentsy-delivery--live');
  }

  function update() {
    document.querySelectorAll('[data-gentsy-delivery]').forEach(function (el) {
      try { render(el); } catch (e) { /* vaste tekst blijft staan */ }
    });
  }

  window.GentsyDelivery = { update: update };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setInterval(update, 30000);
})();
